import { CardStack } from 'targets/web/components/CardStack';

export const Container = CardStack;
